
import { Component, Prop, Vue } from 'vue-property-decorator'

interface TrackingOptions {
  hasOffersTransactionId: number;
  isFreeTrial: boolean;
  isFreemium: boolean;
}

@Component
export default class ModalPixels extends Vue {
  @Prop({ type: Object, default: () => ({}) }) tracking!: TrackingOptions
}
